import { render, staticRenderFns } from "./AppDrag.vue?vue&type=template&id=20b04a35&scoped=true&"
import script from "./AppDrag.vue?vue&type=script&lang=js&"
export * from "./AppDrag.vue?vue&type=script&lang=js&"
import style0 from "./AppDrag.vue?vue&type=style&index=0&id=20b04a35&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b04a35",
  null
  
)

export default component.exports